import { flattenMenuPages, normalizeMenuHierarchy } from "./menuRouteMatcher";
import { menuHasPageCode } from "./menuPageAccess";

export const DISTRIBUTOR_MEMBERS_PATH = "/distributor-members";
export const DISTRIBUTOR_MEMBERS_PAGE_CODE = "altimdakiler";

const normalizeTr = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/ı/g, "i")
    .replace(/İ/g, "i");

export const menuHasDistributorMembers = (items) => {
  if (
    menuHasPageCode(items, DISTRIBUTOR_MEMBERS_PAGE_CODE) ||
    menuHasPageCode(items, "distributor-members") ||
    menuHasPageCode(items, DISTRIBUTOR_MEMBERS_PATH.replace(/^\//, ""))
  ) {
    return true;
  }
  const tree = Array.isArray(items) ? normalizeMenuHierarchy(items) : [];
  const flat = flattenMenuPages(tree.length ? tree : items);
  return flat.some((page) => {
    const name = normalizeTr(page && page.name);
    const url = normalizeTr(page && page.url).replace(/^\/+/, "");
    return (
      name === "altimdakiler" ||
      name.indexOf("altimdakiler") !== -1 ||
      url === "distributor-members" ||
      url.indexOf("distributor-members") !== -1
    );
  });
};

export const ensureDistributorMembersRoutes = (routeList, allRoutes) => {
  const next = Array.isArray(routeList) ? [...routeList] : [];
  if (!Array.isArray(allRoutes)) return next;
  const route = allRoutes.find(
    (item) => item && item.path === DISTRIBUTOR_MEMBERS_PATH
  );
  if (route && !next.some((item) => item.path === route.path)) {
    next.push(route);
  }
  return next;
};
